"use strict";

import angular from "angular";

import template from "./nu-pagination.component.html";
import "./nu-pagination.component.scss";

import {
    getVisiblePages,
    PAGINATION_ELLIPSIS
} from "../../services/pagination-pages";

/**
 * Paginação única do v1. O algoritmo de páginas visíveis é o mesmo do
 * `TablePaginationControls` do v2 — as duas telas mostram a mesma janela de páginas para o
 * mesmo total, senão "unificado" seria só aparência.
 *
 * A página é 1-based na fronteira do componente. Quem usa `PaginationList`/`PaginationListCloud`,
 * que guardam `offset` 0-based, converte na chamada.
 *
 * `loading` trava a barra inteira enquanto a página anterior ainda está sendo buscada. Sem isso,
 * cliques rápidos disparam consultas concorrentes e a última resposta a chegar — que não é
 * necessariamente a da última página pedida — é a que fica na tela.
 */
export class NuPaginationComponent {
    visiblePages = [];

    constructor() {}

    $onInit() {
        this._setVisiblePages();
    }

    $onChanges(changes) {
        if (changes.page || changes.totalPages) this._setVisiblePages();
    }

    getPage() {
        const page = Number(this.page);
        return Number.isFinite(page) && page > 0 ? page : 1;
    }

    getTotalPages() {
        const total = Number(this.totalPages);
        return Number.isFinite(total) && total > 0 ? total : 1;
    }

    isEllipsis(item) {
        return item === PAGINATION_ELLIPSIS;
    }

    isActive(item) {
        return item === this.getPage();
    }

    isBusy() {
        return this.loading === true;
    }

    isFirstPage() {
        return this.isBusy() || this.getPage() <= 1;
    }

    isLastPage() {
        return this.isBusy() || this.getPage() >= this.getTotalPages();
    }

    onSelectPage(page) {
        if (this.isBusy()) return;
        if (page === this.getPage()) return;
        if (page < 1 || page > this.getTotalPages()) return;
        if (this.onChangePage) this.onChangePage({ page });
    }

    _setVisiblePages() {
        this.visiblePages = getVisiblePages(this.getPage(), this.getTotalPages());
    }
}

NuPaginationComponent.$inject = [];

const name = "nuPaginationComponent";
const def = {
    bindings: {
        page: "<",
        totalPages: "<",
        label: "<",
        loading: "<",
        onChangePage: "&"
    },
    controller: NuPaginationComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
